import React, { useEffect, useState } from 'react';
import axios from 'axios';
import BASE_URL from './api/config';
import { useParams } from 'react-router-dom';
import AppointmentModal from './AppointmentModal';

const SlotPage = () => {
  const { id } = useParams();
  const [slots, setSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState(null);

  useEffect(() => {
    axios.get(`${BASE_URL}/get_slots.php?id=${id}`).then(res => {
      setSlots(res.data);
    });
  }, [id]);

  return (
    <div className="container mt-5">
      <h3>Available Slots</h3>
      <div className="d-flex flex-wrap gap-3 mt-3">
        {slots.map((slot, i) => (
          <button key={i} className="btn btn-outline-primary" onClick={() => setSelectedSlot(slot)}>
            {new Date(slot).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
          </button>
        ))}
      </div>

      {selectedSlot && (
        <AppointmentModal
          doctorId={id}
          slot={selectedSlot}
          onClose={() => setSelectedSlot(null)}
        />
      )}
    </div>
  );
};

export default SlotPage;
